import * as React from "react";
import Box from "@mui/material/Box";
import { Autocomplete, TextField } from "@mui/material";

function RetreatDateDropDown(props) {
  const { events, label, id, propValue, onChange, isNew, error } = props;
  const currentEventIndex = events.findIndex((event) => event.id === propValue);
  const [value, setValue] = React.useState(events[currentEventIndex]);
  const [inputValue, setInputValue] = React.useState("");

  const onInputChangeLocal = (value) => {
    onChange(value, id);
  };
  return (
    <Autocomplete
      id={id}
      options={events}
      autoHighlight
      sx={{ minWidth: 330 }}
      getOptionLabel={(option) => `${option.startDateNice}`}
      getOptionDisabled={(option) => option.alreadyRegistered}
      onChange={(e, newValue) => {
        onInputChangeLocal(newValue.id);
        setValue(newValue);
      }}
      value={isNew ? undefined : value}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          {option.startDateNice} ({option.retreatType}'s retreat){" "}
          {option.alreadyRegistered ? "Registered ✓" : null}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          error={error}
          {...params}
          label={label}
          inputProps={{
            ...params.inputProps,
            autoComplete: "off", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}

export default RetreatDateDropDown;
